import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function dateRangeValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const startDate = group.get('warrantyStartDateLte')?.value
    const endDate = group.get('warrantyEndDateGte')?.value

    if (startDate && endDate && startDate > endDate) {
      return { dateRangeInvalid: true }
    }

    return null
  }
}
